import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { RefObject } from "react";

import productCore from "../../core/product.core";
import Dialog from "../form/dialog.comp";

interface DeleteProductDialogProps {
  dialogRef: RefObject<HTMLDialogElement>;
  productId: string;
  clickCancelled?: VoidFunction;
}

export default function DeleteProductDialog({ dialogRef, productId, clickCancelled }: DeleteProductDialogProps) {
  const queryClient = useQueryClient();
  const { isReady } = useRouter();

  async function clickConfirmed() {
    const data = await productCore.deleteProduct(productId);

    if (data.message === "success") {
      queryClient.invalidateQueries({ queryKey: ["products"] });
      queryClient.invalidateQueries({ queryKey: ["productSingle"] });
    }
  }

  if (!isReady) return null;

  return (
    <>
      <Dialog
        title="Delete Product"
        message={`Are You sure to delete this product?`}
        dialogRef={dialogRef}
        confirm={clickConfirmed}
        cancel={clickCancelled}
      />
    </>
  );
}
